
import {
  computed,
  defineComponent,
  PropType,
  watch,
  nextTick
} from '@vue/runtime-core'
import ModalBase from '../genenral/ModalBase.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import HospitalCassette from '@/components/block/HospitalCassette.vue'
import Alert from '@/components/elements/Alert.vue'
import HospitalCassetteOnlineEvent from '@/components/block/HospitalCassetteOnlineEvent.vue'
import EventPrecautionForJoin from '@/components/block/EventPrecautionForJoin.vue'
import ZoomButton from '@/components/block/ZoomButton.vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
dayjs.locale('ja')

export default defineComponent({
  name: 'ModalOnlineEvent',

  components: {
    ModalBase,
    HeadingLv3,
    HospitalCassette,
    Alert,
    HospitalCassetteOnlineEvent,
    EventPrecautionForJoin,
    ZoomButton
  },

  props: {
    selectedProgram: {
      type: Object,
      default: () => ({})
    },
    selectedHospital: {
      type: Object,
      default: () => ({})
    },
    recommendHospitals: {
      type: Array,
      default: () => []
    },
    liveStatus: {
      type: Object,
      default: () => ({})
    },
    precautionHtml: {
      type: String,
      default: ''
    },
    closeEventModal: {
      type: Function as PropType<() => void>,
      required: true
    },
    applyCheckin: {
      type: Function as PropType<
        (type: 'event' | 'hospital', hospital_id?: string) => void
      >,
      required: true
    },
    viewLive: {
      type: Function as PropType<
        (channelName: string, selectedProgramStart: string) => void
      >,
      required: true
    },
    currentTime: {
      type: String,
      required: true
    },
    isCheckInError: {
      type: Boolean,
      required: true
    }
  },

  setup(props) {
    const store = useStore()

    const closeModal = () => {
      store.commit('unFixBody')
      props.closeEventModal()
    }

    // vimeoCheckinは不要だが、watchし続けないと、モーダルが閉じるのでそのまま
    const vimeoCheckin = () => {
      if (
        !props.selectedProgram.zoom_url &&
        props.selectedProgram.movie_url &&
        props.selectedProgram.hospital_id &&
        props.liveStatus.status === 'live'
      ) {
        // サーバー側で、イベントチェックイン処理もまとめて行う applyCheckin('event')
        props.applyCheckin('hospital', props.selectedProgram.hospital_id)
      }
    }
    vimeoCheckin()

    watch(
      () => [props.selectedProgram, props.liveStatus.status],
      () => {
        vimeoCheckin()
        if (props.liveStatus.status === 'after') {
          nextTick(() => {
            setTimeout(() => {
              closeModal()
            }, 1000)
          })
        }
      }
    )

    const time = computed((): string => {
      if (Object.keys(props.selectedProgram).length === 0) return ''
      const program = props.selectedProgram
      return `${program.start_hour}:${program.start_minute} - ${program.end_hour}:${program.end_minute}`
    })

    const hasInformation = computed((): boolean => {
      return Object.keys(props.selectedProgram).length > 0
    })

    const hasMovie = computed((): boolean => {
      return (
        Object.keys(props.selectedProgram).length > 0 &&
        props.selectedProgram.hospital_movie_id
      )
    })

    const isShowHospitalCassette = computed(
      (): boolean =>
        Object.keys(props.selectedHospital).length > 0 &&
        !props.selectedProgram.is_organization_online //WP"団体として追加する"にチェック済していない
    )

    const vimeoUrl = computed(() => {
      return (
        Object.keys(props.selectedProgram).length > 0 &&
        props.selectedProgram.movie_url
      )
    })
    const zoomUrl = computed(() => {
      return (
        Object.keys(props.selectedProgram).length > 0 &&
        props.selectedProgram.zoom_url
      )
    })

    const zoomButtonHandler = () => {
      // サーバー側で、イベントチェックイン処理もまとめて行う applyCheckin('event')
      props.applyCheckin('hospital', props.selectedProgram.hospital_id)
      window.open(zoomUrl.value, '_blank')
    }
    const zoomButtonProps = computed(() => {
      let label = `${props.selectedProgram.eventDate} ${props.selectedProgram.start_hour}:${props.selectedProgram.start_minute}から配信予定`
      let disabled = true
      if (['live', 'soon'].includes(props.liveStatus.status)) {
        label = 'LIVE配信中 視聴はこちら'
        disabled = false
      }
      return {
        label,
        disabled,
        handler: zoomButtonHandler
      }
    })

    const isError = computed(() => props.isCheckInError)
    return {
      time,
      hasInformation,
      hasMovie,
      isShowHospitalCassette,
      vimeoUrl,
      zoomUrl,
      zoomButtonProps,
      closeModal,
      isError
    }
  }
})
